import React from 'react';
import { Composition } from 'remotion';
import { BoldStrokeSubtitle } from '../templates/subtitles';

export const SubtitleTemplatesCompositions: React.FC = () => {
  return (
    <>
      <Composition
        id="BoldStrokeSubtitle-demo"
        component={BoldStrokeSubtitle}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{}}
      />
      <Composition
        id="BoldStrokeSubtitle-staggered"
        component={BoldStrokeSubtitle}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={{
          layout: 'staggered',
          fontSize: 80,
          highlightFontSize: 88,
          strokeWidth: 12,
          normalStrokeColor: '#1a1a2e',
          highlightStrokeColor: '#3d1800',
          highlightColor: '#FFD700',
        }}
      />
    </>
  );
};
